import accountSettingsModule from '../accountSettingsModule';

function personalController(
  $scope,
  $window,
  $log,
  $document,
  accountsService,
  eventStreamService,
  accountConstantsResources,
  realtimeService,
  modalService,
  modalConstantsService
) {
  'ngInject';

  $scope.chooseThemes = function() {
    accountsService.beginSetConsumerThemes($scope.themeContent.newThemeType).then(
      function() {
        // trigger theme update event, in case realtime connection is not ready
        $document.triggerHandler(accountConstantsResources.updateThemeEvent);
      },
      function() {
        modalService.open({
          titleText: modalConstantsService.default.error.title,
          bodyText: modalConstantsService.default.error.body
        });
      }
    );
  };

  $scope.sendThemeUpdateEvent = function(newThemeType, oldThemeType) {
    eventStreamService.sendEventWithTarget(
      eventStreamService.eventNames.account.updateTheme,
      accountConstantsResources.updateThemeEventContext,
      {
        newThemeType,
        oldThemeType
      }
    );
  };

  function themeUpdateCallback() {
    // realtime update theme event triggered by another browser for the same account
    if ($scope.themeContent.oldThemeType === $scope.themeContent.newThemeType) {
      $scope.getCurrentTheme();
      return;
    }

    $scope.sendThemeUpdateEvent($scope.themeContent.newThemeType, $scope.themeContent.oldThemeType);
    $scope.themeContent.oldThemeType = $scope.themeContent.newThemeType;
  }

  const themeUpdateCallbacks = {};
  themeUpdateCallbacks[
    realtimeService.notificationTypes.userThemeTypeChangeNotification.themeUpdate
  ] = themeUpdateCallback;
  realtimeService.listenToNotification(
    realtimeService.realTimeTypes.userThemeTypeChangeNotification,
    themeUpdateCallbacks
  );
}
accountSettingsModule.controller('personalController', personalController);

export default personalController;
